// extracted by mini-css-extract-plugin
export default {"container":"home_container__5wttX","animatedSection":"home_animatedSection__F3eHX","reveal":"home_reveal__ib3oN"};